import React from "react";
import Footer from "../Footer";
import Navbar from "../Navbar";
import image1 from "../../assets/image1.jpg";

const InterestRatePolicy: React.FC = () => {
  const policySections = [
    {
      title: `1. ${import.meta.env.VITE_COMPANY_NBFC} (Brand Name: ${import.meta.env.VITE_COMPANY_NAME})`,
      content: `The Reserve Bank of India (RBI) through its notification DNBS.204/CGM (ASR)-2009 dated January 2, 2009, and the Master Direction DNBR. PD. 007/03.10.119/2016-17 dated September 1, 2016, directs NBFCs and their Boards to review and implement internal interest rate models that factor in the cost of funds, margin, and risk premium. ${import.meta.env.VITE_COMPANY_NBFC} ("Company"), operating under the brand "${import.meta.env.VITE_COMPANY_NAME}," complies with these guidelines and has formulated this Interest Rate Policy in line with the Fair Practices Code.`,
    },
    {
      title: "2. Disclosure",
      content: `The Company's interest rate determination process—including applicable rates and charges—is transparently disclosed on its official website and shared with customers during the loan process.`,
    },
    {
      title: "3. Interest Rate",
      list: [
        "This policy is approved by the Board of Directors and incorporates key factors: cost of funds, margin, and risk premium.",
        "Rates vary by borrower based on risk profile, credit score, and operational costs.",
        "Loan amounts range from ₹5,000 to ₹1,00,000 with tenures between 7 days and 3 months.",
        "Maximum annual rates for Q4 FY2025: 108% (Personal loans), 510.25% (Salary Advance loans).",
        "Target maximum rates for Q4 FY2026: 72% (Personal loans), 382.5% (Salary Advance loans).",
        "All loans are Fixed Rate and repaid through EMIs or Bullet repayment. Interest is payable on due date; penal interest applies for delays.",
      ],
    },
    {
      title: "4. Fees & Charges",
      list: [
        "Borrowers pay fees such as processing, credit assessment, or origination (10–15% of loan amount).",
        "Additional charges apply for EMI returns, rescheduling, or special services.",
        "Applicable taxes and cesses are levied as per law, and all revisions are prospective.",
        "Refunds or waivers may be granted solely at the Company's discretion.",
      ],
    },
    {
      title: "5. Customer Communication",
      content:
        "The final interest rate, applicable fees, and charges are clearly communicated to the borrower at loan sanction through a Sanction Letter and loan documentation. Borrowers receive a copy of the signed loan agreement after disbursal.",
    },
    {
      title: "6. Amendment",
      content:
        "This policy may be revised or updated at any time with the approval of the Board of Directors. All changes, once approved, take immediate effect.",
    },
  ];

  return (
    <div className="min-w-screen bg-[#141237]">
      <div className="flex w-full flex-col items-center justify-center gap-12 px-4 py-16">
        <Navbar />

        {/* Hero Section */}
        <section className="relative text-center text-white py-16 rounded-xl shadow-lg px-6 md:px-12 overflow-hidden w-full max-w-4xl bg-[#F26622]/10">
          <img
            src={image1}
            alt="Interest Rate Policy"
            className="absolute inset-0 w-full h-full object-cover opacity-25"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#141237]/80 via-[#FF2D55]/20 to-[#141237]/80 rounded-xl"></div>
          <div className="relative z-10">
            <h1 className="text-4xl sm:text-5xl font-bold mb-4 drop-shadow-lg">
              Interest Rate Policy
            </h1>
            <p className="text-lg sm:text-xl max-w-3xl mx-auto leading-relaxed drop-shadow-md mt-4">
              At{" "}
              <span className="font-semibold">{import.meta.env.VITE_COMPANY_NAME}</span>, we follow transparent and responsible lending practices guided by RBI regulations for NBFCs. This policy outlines our interest rate determination approach.
            </p>
          </div>
        </section>

        {/* Policy Content */}
        <div className="max-w-4xl w-full mx-auto p-8 bg-white rounded-xl shadow-md text-gray-800 space-y-6">
          {policySections.map((section, idx) => (
            <div key={idx} className="space-y-2">
              <h2 className="text-2xl font-semibold text-[#FF2D55]">
                {section.title}
              </h2>
              {section.content && <p>{section.content}</p>}
              {section.list && (
                <ul className="list-disc list-inside ml-4 space-y-1">
                  {section.list.map((li, i) => (
                    <li key={i}>{li}</li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default InterestRatePolicy;
